__turbopack_context__.v({
  "avatar": "W35C0G_avatar",
  "body": "W35C0G_body",
  "card": "W35C0G_card",
  "category": "W35C0G_category",
  "details": "W35C0G_details",
  "duration": "W35C0G_duration",
  "eligibility": "W35C0G_eligibility",
  "footer": "W35C0G_footer",
  "heading": "W35C0G_heading",
  "image": "W35C0G_image",
  "players": "W35C0G_players",
  "select": "W35C0G_select",
  "status": "W35C0G_status",
  "summary": "W35C0G_summary",
  "time": "W35C0G_time",
  "title": "W35C0G_title",
  "trainer": "W35C0G_trainer",
  "waitlist": "W35C0G_waitlist",
});
